import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Seleciona o elemento raiz no HTML
const rootElement = document.getElementById("root");

// Cria a raiz do React com React 18
const root = ReactDOM.createRoot(rootElement);

// Renderiza o App no DOM
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
